import React from 'react';
import './styles.scss';
import { getI18N } from 'qs-services/i18N';

export default ({ outOfStockClass }) => {
  const { t } = getI18N();
  return <div className={`outOfStockCommonLabel ${outOfStockClass}`}>{t('out_of_stock')}</div>;
};
